import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, Slider } from "@mui/material";
import Divider from '@mui/material/Divider';

import Sliders from '../../components/saving-league/slider';

import { styled } from "@mui/material";
// import point500active from "../../images/diwali/point500active.png";



import { Link } from "react-router-dom";
const thumbimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/thumbimg.png";
const discoverbrand = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/brand.png";
const border = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/border.png";
const point200 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon (2).png";
const point200active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon-active.png";
const point300 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon (3).png";
const point300active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon2-active.png";
const point500 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon (4).png";
const point500active = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon3-active.png";
const CustomSlider = styled(Slider)(({ theme }) => ({
  "& .MuiSlider-mark.MuiSlider-markActive:first-child": {
    background: "transparent",
  },
}));

const images = {
  2: point200active,
  3: point300active,
  5: point500active,
};

// These will be moved inside the component to ensure they're read after data is loaded

// Marks will be created inside the component
export default function FreeMoney() {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [activeLink, setActiveLink] = useState(null);
  const [userData, setUserData] = useState(null);
  
  // State for localStorage values
  const [cashbackGoal1, setCashbackGoal1] = useState(0);
  const [cashbackGoal2, setCashbackGoal2] = useState(0);
  const [cashbackGoal3, setCashbackGoal3] = useState(0);
  const [currentCashback, setCurrentCashback] = useState(0);
  const [sliderValue, setSliderValue] = useState(0);

  useEffect(() => {
    // Load localStorage values
    const goal1 = Number(localStorage.getItem('cashback_goal_1')) || 0;
    const goal2 = Number(localStorage.getItem('cashback_goal_2')) || 0;
    const goal3 = Number(localStorage.getItem('cashback_goal_3')) || 600;
    const current = Number(localStorage.getItem('current_cashback')) || 0;

    setCashbackGoal1(goal1);
    setCashbackGoal2(goal2);
    setCashbackGoal3(goal3);
    setCurrentCashback(current);
    setSliderValue(current);

    // Fetch user data from API for date
    const fetchUserData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const ck_id = params.get('ck_id') || localStorage.getItem('savings_league_ck_id_sep');
        
        if (ck_id) {
          const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl?ck_id=${ck_id}`);
          const data = await response.json();
          
          if (data?.user_data?.user) {
            setUserData(data.user_data.user);
            console.log('🔍 FreeMoney API Response:', data.user_data.user);
          }
        }
      } catch (error) {
        console.error('Error fetching user data in freeMoney:', error);
      }
    };

    fetchUserData();
  }, []);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  // Function to get formatted date from API data only
  const getFormattedDate = () => {
    // Only show date when userData is loaded
    if (!userData) {
      return 'Loading...';
    }
    
    // Try multiple possible locations for the date from API only
    const dateValue = userData?.maxUpdatedAt || 
                     userData?.leaderboards_saving_league_sept?.updatedAt ||
                     userData?.updatedAt;
    
    console.log('🔍 FreeMoney Date Debug:', {
      maxUpdatedAt: userData?.maxUpdatedAt,
      leaderboardUpdatedAt: userData?.leaderboards_saving_league_sept?.updatedAt,
      userUpdatedAt: userData?.updatedAt,
      finalDateValue: dateValue
    });
    
    if (dateValue) {
      const date = new Date(dateValue);
      if (!isNaN(date.getTime())) {
        date.setDate(date.getDate() - 1);
        return date.toLocaleDateString('en-GB', { 
          timeZone: 'Asia/Kolkata'
        });
      }
    }
    return 'N/A';
  };

  // Create marks array based on current cashbackGoal3
  const marks = [
    { value: 0, label: 'Cashback Goal' },
    { value: Math.round(cashbackGoal3 / 3), label: `${Math.round(cashbackGoal3 / 3)}` },
    { value: Math.round(cashbackGoal3 * 2 / 3), label: `${Math.round(cashbackGoal3 * 2 / 3)}` },
    { value: cashbackGoal3, label: `${cashbackGoal3}` },
  ];
  
  const segment = localStorage.getItem('segment')

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const data = [
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Ceazur.png",
      // title: "Samsung",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/ceazur-coupons-lead2025"
        : "cashkaro://stores/ceazur-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Clove Oral Care.png",
      // title: "Booking.com",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/clove-oral-care-coupons-lead2025"
        : "cashkaro://stores/clove-oral-care-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Veeba.png",
      // title: "BoAt",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/veeba-coupons-lead2025"
        : "cashkaro://stores/veeba-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/House of Koala.png",
      // title: "Trumeds",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/house-of-koala-offers-lead2025"
        : "cashkaro://stores/house-of-koala-offers-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/HSBC Platinum LTF Card.png",
      // title: "Adidas",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/hsbc-platinum-credit-card-lead2025"
        : "cashkaro://stores/hsbc-platinum-credit-card-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Koparo Clean.png",
      // title: "XYXX Crew",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/koparoclean-coupons-lead2025"
        : "cashkaro://stores/koparoclean-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Marks & Spencer.png",
      // title: "Nykaa",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/marks-and-spencer-offers-lead2025"
        : "cashkaro://stores/marks-and-spencer-offers-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Fitspire.png",
      // title: "mCaffiene",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/fitspire-coupons-lead2025"
        : "cashkaro://stores/fitspire-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/Swiss Beauty.png",
      // title: "Strch",
      // cashback: '5%',
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/swiss-beauty-coupons-lead2025"
        : "cashkaro://stores/swiss-beauty-coupons-lead2025",
    },
    // {
    //   imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/cloveee.png",
    //   title: "Clove",
    //   cashback: '25%',
    //   link: segment == 1 || segment == 2 || segment == 4
    //     ? "cashkaro://stores/clove-oral-care-coupons"
    //     : "cashkaro://stores/clove-oral-care-coupons",
    // },

    
  ];
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <Grid container sx={{ background: "#fff" }}>
      <style>
        {
          `
          .MuiSlider-valueLabelCircle{ display:none}
          `
        }
      </style>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Grid
          sx={{
            background: '#1F162E',

            width: "100%",
          }}
        >
          <Grid pb={2}>
            <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/free-money.png" style={{ width: "100%", }} />
          </Grid>
          <Grid>
            <Box px={3}>
              <Typography sx={{ textAlign: 'center', fontWeight: '500', fontSize: '0.875rem', lineHeight: '140%', color: '#fff' }}>Points</Typography>
            </Box>


            <Grid>
              <Box
                sx={{
                  padding: "0 0",
                  position: "relative",
                }}
                mt={2}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 32px",
                  }}
                  mb={0.75}
                >
                  <Typography
                    sx={{
                      color: "#7524CE",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",
                      // width: "30%",
                      textAlign: "left"

                    }}
                  >
                    Points
                  </Typography>
                  <Typography
  sx={{
    color: "#FFCE00",
    textAlign: "center",
    fontFamily: "Metropolis",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "10px",
    textShadow: currentCashback >= cashbackGoal1 ? "0 0 10px #FFCE00, 0 0 10px #FFCE00, 0 0 15px #FFCE00" : "none"
  }}
>
  100 
  {/* {localStorage.getItem("free_money_1") || 0} */}
</Typography>
                  <Typography
                    sx={{
                      color: "#FFCE00",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",
                      textShadow: currentCashback >= cashbackGoal2 ? "0 0 10px #FFCE00, 0 0 10px #FFCE00, 0 0 15px #FFCE00" : "none"


                    }}
                  >
                    +150
                    {/* {localStorage.getItem('free_money_2') || 0} */}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFCE00",
                      textAlign: "right",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",
                      textShadow: currentCashback >= cashbackGoal3 ? "0 0 10px #FFCE00, 0 0 10px #FFCE00, 0 0 15px #FFCE00" : "none"


                    }}
                  >
                    +200
                     {/* {localStorage.getItem('free_money_3') || 0} */}
                  </Typography>
                </Box>
                <Box sx={{ padding: "0 40px" }}>
                  <CustomSlider
                    aria-label="Temperature"
                    defaultValue={currentCashback}
                    value={sliderValue}
                    onChange={handleSliderChange}
                    valueLabelDisplay="off"
                    valueLabelFormat={(value) => (value === 0 ? "No streak yet" : ` ₹${currentCashback}`)}
                    step={1}
                    marks={marks}
                    disabled
                    min={0}
                    max={cashbackGoal3}
                    sx={{
                      color: "#E85F34", // Change the color here
                      padding: "4px !important",
                      boxShadow: "0px 0px 0px",
                      borderRadius: "20px",
                      zIndex: "222",
                      fontFamily: 'Metropolis',
                      position: "relative",
                      height: 11,
                      '& .MuiSlider-valueLabel': {
                        bgcolor: 'transparent', // Background color of the label
                        color: 'white', // Text color of the label
                        borderRadius: 1, // Rounded corners
                        padding: '4px 8px', // Padding around the label
                        fontSize: "8px",
                        position: "absolute",
                        top: "calc(100% + 16px)", // Adjust to place tooltip below
                        left: "-65%",
                        transform: "translateX(-50%)", // Center tooltip horizontally
                      },


                      '& .MuiTooltip-tooltip': {

                        bgcolor: 'transparent', // Background color of the label
                        color: 'white', // Text color of the label
                        borderRadius: 1, // Rounded corners
                        padding: '4px 8px', // Padding around the label
                        fontSize: "8px",
                        position: "absolute",
                        top: "calc(100% + 16px)",
                        left: "50%",
                        transform: "translateX(-50%)", // Center tooltip horizontally
                      },
                      '&.Mui-disabled': {
                        color: '#FFBF00',
                      },
                      "& .MuiSlider-thumb": {
                        height: 26,
                        width: 37,
                        background: `url(${thumbimg})`, // Change thumb image
                        "&:focus, &:hover, &.Mui-active": {
                          boxShadow: "inherit",
                        },
                        ":before": {
                          boxShadow: "0px 0px 0px",
                        },
                       "&::after": {
  content: `"₹${currentCashback >= cashbackGoal3 ? cashbackGoal3 + '+' : currentCashback}"`,
  position: "absolute",
  top: "5px",
  color: "#FFF",
  left: "-10%",
  fontSize: "12px", // Adjust size
  fontWeight: "bold",
  transform: "none"
},

                      },
                      "& .MuiSlider-track": {
                        height: 13, // Change track height
                      },
                      "& .MuiSlider-rail": {
                        height: 11, // Change rail height
                        backgroundColor: "#36276A", // Rail color
                        opacity: "1",
                      },
                      "& .MuiSlider-mark": {
                        backgroundColor: "#36276A", // Mark color
                        height: 15, // Mark height
                        width: 2, // Mark width
                        borderRadius: "20px",
                        '&.MuiSlider-markActive': {
                          backgroundColor: '#FFBF00', // Active mark color
                        },
                      },
                      "& .MuiSlider-markLabel": {
                        color: "#fff",
                        fontSize: "10px",
                        lineHeight: '10px',
                        fontWeight: '500',
                        top: "24px !important",
                      },
                      "& .MuiSlider-markLabel:first-of-type": {
                        marginLeft: "8px",
                      },
                      "& .MuiSlider-markLabel:last-of-type": {
                        marginRight: "8px",
                      },
                      "& .MuiSlider-markLabel": {
      display: "none", // 👈 hide labels below marks too
    },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 32px 0 20px",
                  }}
                  mb={0.75}
                  mt={-2}
                >
                  <Typography
                    sx={{
                      color: "#7524CE",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",
                      // width: "30%",
                      textAlign: "left"

                    }}
                  >
                    CB Goal
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",
                      width:'10%'

                    }}
                  >
                    + {cashbackGoal1}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",

                    }}
                  >
                    + {cashbackGoal2}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      textAlign: "right",
                      fontFamily: "Metropolis",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "10px",

                    }}
                  >
                    + {cashbackGoal3}
                  </Typography>
                </Box>

              </Box>
              <Box px={3} mt={4}>
                <Typography sx={{ textAlign: 'center', fontWeight: '500', fontSize: '0.875rem', lineHeight: '140%', color: '#fff' }}>Free Money</Typography>
              </Box>
              <Grid container spacing={1} px={1}>

                {/* First Item */}
                <Grid item xs={4} sm={4}>
                  <Box
                    sx={{
                      backgroundImage: (cashbackGoal1 > currentCashback)
                        ? `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/inactive.png')`
                        : `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/active.png')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      minHeight: '160px',
                    }}
                  >
                    <Typography
                      sx={{
                        color: (cashbackGoal1 > currentCashback) ? '#7524CE ' : '#FFCE00',
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '14px',
                      }}
                    >
                      ₹{localStorage.getItem('free_money_1') || 0}
                      <br />Free Money
                    </Typography>
                  </Box>

                  <Typography sx={{ color: '#FFF', textAlign: 'center', fontWeight: '400', fontSize: '9px', lineHeight: '10px' }}>
                    {cashbackGoal1 > currentCashback ? (
                      <>Unlocks at ₹{cashbackGoal1}<br /> Cashback</>
                    ) : (
                      'Unlocked'
                    )}
                  </Typography>




                </Grid>

                {/* Second Item */}
                <Grid item xs={4} sm={4}>
                  <Box
                    sx={{
                      backgroundImage: (cashbackGoal2 > currentCashback)
                        ? `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/inactive.png')`
                        : `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/active.png')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      minHeight: '160px',
                    }}
                  >
                    <Typography
                      sx={{
                        color: (cashbackGoal2 > currentCashback) ? '#7524CE' : '#FFCE00',
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '14px',
                      }}
                    >
                     + ₹{localStorage.getItem('free_money_2') || 0} <br />Free Money
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography sx={{ color: '#FFF', textAlign: 'center', fontWeight: '400', fontSize: '9px', lineHeight: '10px' }}>
                      {cashbackGoal2 > currentCashback
                        ? (
                          <>
                            Unlocks at ₹{cashbackGoal2}
                            <br />
                            Cashback
                          </>
                        )
                        : 'Unlocked'
                      }
                    </Typography>

                  </Box>
                </Grid>


                {/* Third Item */}
                <Grid item xs={4} sm={4}>
                  <Box
                    sx={{
                      backgroundImage: (cashbackGoal3 > currentCashback) ? `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/inactive.png')` : `url('https://d2sriifpjiqv0p.cloudfront.net/diwali/active.png')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      minHeight: '160px'
                    }}
                  >
                    <Typography sx={{
                      color: (cashbackGoal3 > currentCashback) ? ' #7524CE' : '#FFCE00',

                      fontSize: '14px', fontWeight: '700', lineHeight: '14px'
                    }}>
                     + ₹{localStorage.getItem('free_money_3') || 0}<br /> Free Money
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography sx={{ color: '#FFF', textAlign: 'center', fontWeight: '400', fontSize: '9px', lineHeight: '10px' }}>
                      {cashbackGoal3 > currentCashback ? (
                        <>Unlocks at ₹{cashbackGoal3} <br />Cashback</>
                      ) : (
                        'Unlocked'
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>


          </Grid>
          <Box>
                        <Typography
                          sx={{
                            color: "rgba(255, 255, 255, 0.50)",
                            textAlign: "center",
                            fontFamily: "Metropolis",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "140%",
                          }}
                          mt={4}
                        >
                     <span>*Last updated on {getFormattedDate()}</span>
          
                        </Typography>
                      </Box>
          <Box px={7} pb={3} mt={5} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Divider sx={{ borderColor: '#fff', borderWidth: '1px', width: '250px' }} />
          </Box>
          <Grid pt={2} px={3}>
            <Typography sx={{ fontWeight: '700', fontSize: '1rem', fontFamily: 'metropolis', textAlign: 'center', lineHeight: '140%' }}>Want to reach your goal faster?</Typography>
            <Typography sx={{ fontWeight: '500', fontSize: '12px', fontFamily: 'metropolis', textAlign: 'center', lineHeight: '140%' }} mt={1}>Save big with these brands!</Typography>
          </Grid>
          <Grid
  container
  spacing={0}
  sx={{ justifyContent: "center" }}
  pb={5}
  pl={2}
  pr={2}
>
  {data.map((item, index) => (
    <Grid
      item
      xs={4}
      key={index}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column", // stack image + text vertically
      }}
      mt={3}
    >
      <a
        href={item.link}
        style={{ textDecoration: "none", width: "100%", textAlign: "center" }}
        target="_blank"
        onClick={() => handleLinkClick(item.link)}
      >
        <img
          src={item.imgSrc}
          style={{
            width: "65%",
            margin: "0 auto", // ensures centering
            display: "block", // avoids flex pushing
          }}
          alt={item.title}
        />
        <Typography
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Metropolis",
            fontSize: "8px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "120%",
            mt: 1,
          }}
        >
          {item.title}
        </Typography>
      </a>
    </Grid>
  ))}
</Grid>


        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>{" "}
    </Grid>
  );
}
